import { createClient } from '@connectrpc/connect';
import { createConnectTransport } from '@connectrpc/connect-web';
import { MetricService } from '@buf/alconostdev_alconost.bufbuild_es/alconost/metric/v1/metric_pb.js';

const transport = createConnectTransport({
    baseUrl: 'https://services.alconost.dev',
});

const client = createClient(MetricService, transport);

export const listMetrics = async () => {
    try {
        const request = {};
        const response = await client.listMetrics(request);
        console.log('List metrics response:', response);
        return response;
    } catch (error) {
        console.error('Error listing metrics:', error);
        throw error;
    }
};

